import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EditIcon from '@mui/icons-material/Edit';
import { Box, Chip, IconButton, Typography, useTheme } from '@mui/material';

import { useSavedConceptGroupAndAttributeCard } from './useSavedConceptGroupAndAttributeCard';
import { AddedConcept } from '../../state/createProjectSlice';

interface SavedConceptGroupAndAttributeCardProps {
  concept: AddedConcept;
  mandatoryAttributeNames: string[];
}

export const SavedConceptGroupAndAttributeCard = ({
  concept,
  mandatoryAttributeNames,
}: SavedConceptGroupAndAttributeCardProps) => {
  const theme = useTheme();

  const { handleEditConcept, removeAddedConcept } = useSavedConceptGroupAndAttributeCard({
    concept,
  });
  return (
    <Box
      key={concept.conceptGroupName}
      sx={{
        border: `1px solid ${theme.palette.divider}`,
        p: theme.spacing(4),
        borderRadius: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(4),
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="body1">{concept.conceptGroupName}</Typography>
        <Box>
          <IconButton size="small" onClick={handleEditConcept}>
            <EditIcon sx={{ fontSize: '20px' }} />
          </IconButton>
          <IconButton size="small" onClick={removeAddedConcept}>
            <DeleteOutlineIcon sx={{ fontSize: '20px' }} />
          </IconButton>
        </Box>
      </Box>
      <Box sx={{ display: 'flex', gap: theme.spacing(1) }}>
        {mandatoryAttributeNames.map((attributeName) => (
          <Chip
            key={attributeName}
            label={attributeName}
            variant="outlined"
            size="small"
            sx={{
              backgroundColor: theme.palette.grey[200],
              fontSize: '13px',
              border: 0,
            }}
          />
        ))}

        {concept.requiredAttributes.map((attribute) => (
          <Chip
            key={attribute.id}
            label={attribute.label}
            variant="outlined"
            size="small"
            sx={{
              backgroundColor: theme.palette.grey[200],
              fontSize: '13px',
              border: 0,
            }}
          />
        ))}
      </Box>
    </Box>
  );
};
